var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransferCashKb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.688 12.469H11.063c-1.16 0-2.063.945-2.063 2.062v15.125c0 1.16.902 2.063 2.063 2.063h20.624a2.063 2.063 0 0 0 2.063-2.063V14.531c0-1.117-.945-2.062-2.063-2.062Zm-15.813 15.64c0 .301-.258.516-.516.516h-3.093a.496.496 0 0 1-.516-.516v-1.718c0-.258.215-.516.516-.516h3.093c.258 0 .516.258.516.516v1.718Zm8.25 0c0 .301-.258.516-.516.516h-5.843a.496.496 0 0 1-.516-.516v-1.718c0-.258.215-.516.516-.516h5.843c.258 0 .516.258.516.516v1.718Z",
    fill: "#E25F6C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransferCashKb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transfer-cash-kb.53065188adfc5b836b50c03e7ee5cdb9.svg";